import React from "react";
import mainContext from "../../../contexts/mainContext";
import { deleteData } from "../../../Controllers/AppManagement/babySitter";
import {
  AddSeekersNeedsController,
  getSeekersNeedsController,
} from "../../../Controllers/AppManagement/customer";

import {
  __constants,
  __snackBarText,
  __snackBarSeverity,
} from "../../../constants";
import ImageTextListManager from "../common/ImageTextListManager";

export default function SeekerNeeds() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Seeker needs"
      dialogTitle="Add need"
      textLabel="Need"
      getData={getSeekersNeedsController}
      addData={AddSeekersNeedsController}
      deleteData={deleteData}
      editTitle="Update need"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}
